import { jsx as _jsx } from "react/jsx-runtime";
export function ClickTrackingPixel(_a) {
    var url = _a.url;
    if (!url || url.trim() === "") {
        return null; // Return null if the URL is empty or undefined
    }
    var pixelStyle = {
        display: "none",
        marginBottom: "-1px",
    };
    return (_jsx("img", { src: url, width: 1, height: 1, style: pixelStyle, alt: "", tabIndex: -1, "aria-hidden": true }));
}
